import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Image, Tag, Typography } from "antd";
import { DEFAULT_IMAGE_URL } from "../../utils/contrains";
import { isNullorEmpty } from "../../utils/dataUtil";
const { Text } = Typography;
class MyParticipantWorksBrowseModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  static propTypes = {
    participant: PropTypes.object,
  };

  state = {
    item: {},
  };

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.init();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  // 操作互動處理 //////////////////////////////////////////////

  init = () => {
    const participant = this.props.participant;
    this.setState({ item: participant });
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      EnrollCode,
      EnrollName,
      ClassroomTwName,
      ContactPerson,
      ContactPhone,
      ContactEmail,
      Teams,
      AttachedfileA,
      AttachedfileB,
      AttachedfileC,
      Title,
      Description,
    } = this.props.participant;
    const title = "報名者：" + EnrollName + "(" + EnrollCode + ")";
    const fileA = DEFAULT_IMAGE_URL + AttachedfileA;
    const fileB = DEFAULT_IMAGE_URL + AttachedfileB;
    const fileC = DEFAULT_IMAGE_URL + AttachedfileC;
    return (
      <Card title={title} extra={ClassroomTwName}>
        {isNullorEmpty(AttachedfileA) ? (
          <div style={{ width: "100%", textAlign: "center" }}>
            <p style={{ margin: "auto" }}>
              <Text type="danger" underline>
                尚無<Text mark>[全身立繪]</Text>作品照片
              </Text>
            </p>
          </div>
        ) : (
          <Image width={"100%"} height={150} src={fileA} />
        )}
        {isNullorEmpty(AttachedfileB) ? (
          <div
            style={{ width: "100%", textAlign: "center", marginBottom: "4px" }}
          >
            <p style={{ margin: "auto" }}>
              <Text type="danger" underline>
                尚無<Text mark>[角色Ｑ版]</Text>作品照片
              </Text>
            </p>
          </div>
        ) : (
          <Image width={"100%"} height={150} src={fileB} />
        )}

        <table width={"100%"}>
          <tr style={{ backgroundColor: "white" }}>
            <td width={"30%"} align="right">
              <Tag color="purple">
                <i
                  className="fa fa-universal-access"
                  style={{ marginRight: "6px" }}
                ></i>
                角色名稱
              </Tag>
            </td>
            <td width={"70%"}>{Title}</td>
          </tr>
          <tr style={{ backgroundColor: "white" }}>
            <td width={"30%"} align="right">
              <Tag color="purple">
                <i className="fa fa-comment" style={{ marginRight: "6px" }}></i>
                創作理念
              </Tag>
            </td>
            <td>
              <Text>{Description}</Text>
            </td>
          </tr>
          <tr style={{ backgroundColor: "white" }}>
            <td width={"30%"} align="right">
              <Tag color="purple">
                <i className="fa fa-users"></i> 團隊成員
              </Tag>
            </td>
            <td>{Teams}</td>
          </tr>

          <tr style={{ backgroundColor: "white" }}>
            <td width={"30%"} align="right">
              <Tag color="purple">
                <i
                  className="fa fa-address-book"
                  style={{ marginRight: "7px" }}
                ></i>
                聯絡資訊
              </Tag>
            </td>
            <td>
              <i
                className="fa fa-user-circle"
                style={{ marginRight: "4px" }}
              ></i>
              {ContactPerson}
              <br />
              <i className="fa fa-phone" style={{ marginRight: "4px" }}></i>
              {ContactPhone}
              <br />
              <i
                className="fa fa-envelope-open"
                style={{ marginRight: "4px" }}
              ></i>
              {ContactEmail}
            </td>
          </tr>
          <tr style={{ backgroundColor: "white" }}>
            <td width={"30%"} align="right">
              <Tag color="purple">
                <i className="fa fa-cc"></i>著作權切結書
              </Tag>
            </td>
            <td>
              {isNullorEmpty(AttachedfileC) ? (
                <Text type="danger" underline>
                  尚未上傳授權書
                </Text>
              ) : (
                <a
                  href={fileC}
                  download="授權書"
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-info btn-sm"
                >
                  {" "}
                  <i
                    className="fa fa-download"
                    style={{ marginRight: "4px" }}
                  ></i>{" "}
                  授權書下載
                </a>
              )}
            </td>
          </tr>
        </table>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(MyParticipantWorksBrowseModal);
